if (!window.Eurus.loadedScript.has('featured-blog.js')) {
  window.Eurus.loadedScript.add('featured-blog.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedBlog', (sectionId, container) => ({
        sectionId: sectionId,
        loading: true,
        show_more: true,
        loadData() {
          // Posts are already server-rendered in this section; the original ?section_id=
          // fetch discarded its response entirely and only delayed reveal behind a skeleton
          // (and could stick on network failure). Reveal the server-rendered posts immediately.
          this.loading = false;
        }
      }));
    });
  });
}